module.exports = __webpack_public_path__ + "img/franjo_takac.e8dd1215.png";